export default __webpack_public_path__ + "static/Inter-Medium-0c847eef221e164c17da95afc3af6e92.woff";